<template>
	<div class="form-line" :style="{ gridTemplateColumns: gridTemplateColumns }">
		<slot />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				gridTemplateColumns: '1fr'
			};
		},
		mounted() {
			var columns = [];

			for (var i = 0; i < this.$children.length; ++i) {
				columns.push(this.$children[i].weight ? this.$children[i].weight + 'fr' : '1fr');
			}

			console.log(columns.join(' '));

			this.gridTemplateColumns = columns.join(' ');
		}
	}
</script>

<style lang="scss">
	.form-line {
		display: grid;
		column-gap: 20px;
	}
</style>